import { Component } from '@angular/core';

@Component({
  selector: 'app-shipping-policy',
  templateUrl: './shipping-policy.component.html',
  styleUrl: './shipping-policy.component.scss'
})
export class ShippingPolicyComponent {

}
